"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatus = exports.JobStartReason = void 0;
var JobStartReason;
(function (JobStartReason) {
    JobStartReason["SYNC"] = "sync";
    JobStartReason["MIGRATION"] = "migration";
    JobStartReason["OLD"] = "old";
    JobStartReason["AUTO_SYNC"] = "auto_sync";
    JobStartReason["DATASOURCE_CREATION"] = "datasource_creation";
    JobStartReason["DATASOURCE_EDITION"] = "datasource_edition";
    JobStartReason["MANUAL_TAB"] = "manual_tab";
    JobStartReason["FORMULA"] = "formula";
    JobStartReason["WHAT_IF"] = "what_if";
})(JobStartReason = exports.JobStartReason || (exports.JobStartReason = {}));
var JobStatus;
(function (JobStatus) {
    JobStatus["WAITING"] = "waiting";
    JobStatus["PROCESSING"] = "processing";
    JobStatus["FINISHED"] = "finished";
    JobStatus["ERROR"] = "error";
    JobStatus["CANCELED"] = "canceled";
})(JobStatus = exports.JobStatus || (exports.JobStatus = {}));
